import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import { router } from './_helpers/router';
import { store } from './_store/index';
import * as VueGoogleMaps from 'vue2-google-maps';
import moment from 'moment';
import Vuetify from 'vuetify';
import de from 'vuetify/es5/locale/de';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAx7Ckjnlfdwwb7LVoM9NXNkKI-mUX67ac',
    libraries: 'places',
    region: 'DE',
    language: 'de'
  }
});

Vue.use(Vuetify, {
  lang: {
    locales: { de },
    current: 'de'
  }
});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY hh:mm');
  }
});

Vue.config.productionTip = true;
// eslint-disable-next-line
var bus = new Vue({});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
